/**
 * Esqueleto da Central com a mesma altura dos blocos finais: o painel
 * atualiza sozinho e um salto de layout a cada carga e desorientador.
 */

import { KpiCardSkeleton } from '../../../components/KpiCard';

const BLOCO = 'animate-pulse rounded-2xl border border-line bg-surface';

export function EsqueletoCentral(): JSX.Element {
  return (
    <>
      <p role="status" className="sr-only">
        Carregando a Central
      </p>
      <div aria-hidden="true" className="flex flex-col gap-6">
        <div className="grid gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <KpiCardSkeleton emphasis />
          </div>
          <div className={`min-h-[12rem] ${BLOCO}`} />
        </div>
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
            <KpiCardSkeleton key={i} />
          ))}
        </div>
        <div className="grid gap-6 lg:grid-cols-3">
          <div className={`h-80 lg:col-span-2 ${BLOCO}`} />
          <div className={`h-80 ${BLOCO}`} />
        </div>
        <div className="grid gap-6 lg:grid-cols-3">
          <div className={`h-80 lg:col-span-2 ${BLOCO}`} />
          <div className={`h-80 ${BLOCO}`} />
        </div>
        <div className={`h-64 ${BLOCO}`} />
        <div className={`h-96 ${BLOCO}`} />
        <div className="grid gap-6 lg:grid-cols-2">
          <div className={`h-64 ${BLOCO}`} />
          <div className={`h-64 ${BLOCO}`} />
        </div>
      </div>
    </>
  );
}
